module.exports = __webpack_public_path__ + "media/images/supporters_lp/fork22-9ea9627e3973653cad2ad99629b6e07f.png";